module.exports = __webpack_public_path__ + "6fb5af379618cef52817e033598f26bc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/sa.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/sa.svg
// module chunks = 0